import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9bb7a4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mx-auto flex justify-center" }
const _hoisted_2 = { class: "border-b-2 border-fuchsia-600 w-4/5 text-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3 mb-10",
  role: "alert"
}, [
  /*#__PURE__*/_createTextVNode(" このサイトはライバーのユニット・CP等の表現を含みます。ご注意ください。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 詳しい規約については "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/terms",
    class: "underline"
  }, "利用規約"),
  /*#__PURE__*/_createTextVNode("・"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/guideline",
    class: "underline"
  }, "ご利用の前に"),
  /*#__PURE__*/_createTextVNode("を御覧ください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("当サイトのご利用を継続される場合，規約に同意したものとみなします。 ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl mb-5" }, "News", -1))
const _hoisted_5 = { class: "w-4/5 mx-auto" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "text-sm m-auto mx-3" }
const _hoisted_9 = {
  key: 0,
  class: "text-sm mx-3 m-auto text-center inline-block rounded-lg p-3 py-1 bg-blue-400 text-white"
}
const _hoisted_10 = {
  key: 1,
  class: "text-sm mx-3 m-auto text-center inline-block rounded-lg p-3 py-1 bg-pink-400 text-white"
}
const _hoisted_11 = {
  key: 2,
  class: "text-sm mx-3 m-auto text-center inline-block rounded-lg p-3 py-1 bg-yellow-400 text-white"
}
const _hoisted_12 = { class: "text-md title mx-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl mx-3 mt-10 mb-5" }, "登録されているユニット/CP一覧", -1))
const _hoisted_14 = { class: "flex flex-wrap w-4/5 mx-auto" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "card mx-2 p-3 hover:bg-gray-200" }
const _hoisted_17 = { class: "card_text text-md lg:text-lg mx-3 m-1 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RulePopup = _resolveComponent("RulePopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_RulePopup),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.announce_data, (announce) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "text-xl",
              key: announce.id
            }, [
              _createElementVNode("li", _hoisted_6, [
                _createElementVNode("a", {
                  href: announce.url,
                  class: "flex flex-wrap"
                }, [
                  _createElementVNode("time", _hoisted_8, _toDisplayString(announce.published_at), 1),
                  (announce.Category === 'お知らせ')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, " お知らせ "))
                    : _createCommentVNode("", true),
                  (announce.Category === '運営情報')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, " 運営情報 "))
                    : _createCommentVNode("", true),
                  (announce.Category === 'メンテナンス')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, " メンテナンス "))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(announce.Title), 1)
                ], 8, _hoisted_7)
              ])
            ]))
          }), 128))
        ])
      ]),
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.units, (unit) => {
          return (_openBlock(), _createElementBlock("div", {
            key: unit.id,
            class: "mb-2 sm:w-1/2 lg:w-1/4 xl:w-1/5 w-full"
          }, [
            _createElementVNode("a", {
              href: unit.url
            }, [
              _createElementVNode("article", _hoisted_16, [
                _createElementVNode("p", _hoisted_17, _toDisplayString(unit.original_name), 1)
              ])
            ], 8, _hoisted_15)
          ]))
        }), 128))
      ])
    ])
  ]))
}